export default __webpack_public_path__ + "static/media/2.717a07c2.svg";